import { Api } from '../api/Api.js'

export function apiGetFilterData() {
  return Api('get', '/paymentable/get_filter_data')
}

export function apiDoOnlinePayment(payment_able_id, params) {
  return Api('post', `/online-payment/${payment_able_id}/process-payment`, {params})
}

export function apiSendVerificationCode(params) {
  return Api('get', '/online-payment/send-verification-code', {params})
}


export const apiConfirmBankNameMismatch = (params) => {
  return Api('post', '/paymentables/confirm-bank-name-and-send-code', params)
}

export function apiGetPaymentAbles(params, controller) {
  return Api('get', '/paymentable/get', {params, controller})
}

export function apiGetOptionsPayFor() {
  return Api('get', '/paymentable/get_options_pay_for')
}

export function apiUndoCanceledPaymentAble(payment_able_id) {
  return Api('get', `/paymentable/undo_cancel/${payment_able_id}`)
}

export function apiCancelPaymentAble(payment_able_id) {
  return Api('get', `/paymentable/cancel/${payment_able_id}`)
}

export function getPayForTitlePaymentAble(payment_able) {
  if(payment_able) {
    if(payment_able.pay_for === 'order_to_payment' && payment_able.other_snd_id) {
      return payment_able.other_sanad?.title_type || 'نا مشخص';
    } else {
      return payment_able.pay_for_title || '-/-';
    }
  }
}
